module.exports = __webpack_public_path__ + "img/House1.fe32df5.jpg";